<template>
  <section>
    <Banner value="Lista de materiais" />

    <section style="background: #ddd">
      <v-container grid-list-xl>
        <v-layout row wrap my-2>
          <v-flex xs12>
            <p class="lead">Material Didático</p>
            <p>
              A Escola Engenho não adota sistema de ensino apostilado. O
              material didático adotado está de acordo com a proposta pedagógica
              da escola, valorizando a diversidade, a autonomia e a autoria dos
              professores em sala de aula.
            </p>
            <p>
              Selecione a lista de materiais de acordo com o ano letivo do
              aluno:
            </p>
          </v-flex>

          
    <v-container grid-list-lg>
      <v-layout row wrap my-4>
        <v-flex xs6 sm4 v-for="(o, i) in $store.state.materiais" :key="i">
          <v-hover>
            <!-- :href="o.link" (forma quando material está disponível) -->
            <!-- v-on:click="emBreve" (para quando se deve aguardar publicação) -->
            <v-btn
              :href="o.link"
              slot-scope="{ hover }"
              :class="`elevation-${hover ? 12 : 2}`"
              :color="colors[i]"
              dark
              outline
              large
              block
              target="_blank"
              style="
                padding-top: 50px;
                padding-bottom: 50px;
                text-align: center;
                margin: 0;
                height: 170px;
              "
            >
              <div>
                <v-icon style="font-size: 40px">file_copy</v-icon>
                <span style="display: block; font-size: 20px"
                  >{{ o.title }} ano</span
                >
              </div>
            </v-btn>
          </v-hover>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import Banner from "../../components/Banner";

export default {
  data: () => ({
    colors: [
      "blue",
      "orange",
      "blue",
      "orange",
      "blue",
      "orange",
      "blue",
      "orange",
      "blue"
    ]
  }),
  methods: {
    emBreve() {
      alert(
        "Material e os livros didáticos adotados em 2024 serão disponibilizados em breve."
      );
    }
  },
  components: {
    Banner
  }
};
</script>

<style lang="scss" scoped>
p,
h2 {
  text-align: center !important;
}

.manual-btn {
  width: 100%;
  padding: 24px 12px;
  padding-top: 24px;
  padding-bottom: 24px;
  text-align: center;
  margin: 0 auto;

  @media (min-width: 520px) {
    width: max-content;
  }
}
</style>
